<template>
  <div>

    <div class="card shadow mt-2 mb-3 border-0">
      <div class="card-body">
        <div class="title">
          <div class="wrap">
            <h5>Управление ссылками <span class="badge bg-secondary">Загружено: {{ all_count }}</span></h5>
            <div class="sub-title">Добавьте ссылки на площадки и назначьте группы</div>
          </div>
          <button class="btn btn-outline-secondary ms-auto btn-sm" @click.prevent="$modal('show', 'resource_all_list')">
            <i class="bi bi-info-circle"></i> Поддерживаемые домены
          </button>
          <button class="btn btn-primary ms-3 btn-sm" @click.prevent="$modal('show', 'load_links')">
            <i class="bi bi-plus-lg"></i> Добавить ссылку
          </button>
        </div>
        <form @submit.prevent="getData()" class="search-area">
          <input v-model="search" class="form-control" placeholder="Поиск по сылке"/>
          <button type="submit" class="btn btn-outline-dark btn-sm" title="Найти"><i
              class="bi bi-search"></i></button>
          <button class="btn btn-sm" @click.prevent="search=''; getData()" v-if="search" title="Очистить"><i
              class="bi bi-x"></i></button>
        </form>
        <ul class="links list-unstyled">
          <li style="height: 0; border: 0;">

            <div class="resource">
            </div>

            <div class="link">
              <div class="name">
              </div>
              <span><popper hover content="Добавляет ссылкку на отслеживание для получения уведомлений о новых отзывах">
    <i class="bi bi-info-circle pointer"></i>
  </popper></span>
            </div>
            <div class="buttons ms-auto text-white">
              <div class="col">

                Проверка
              </div>
              <div class="col">


                Группа
              </div>

              Удалить
            </div>
          </li>
          <li v-for="link in objects">

            <div class="resource">
                  <span class="img" v-if="link.resource.ico"
                        :style="{backgroundImage: `url(${ link.resource.ico})`}"></span>
              <span class="img no-image" v-else
                    :style="{backgroundColor: link.resource.color + '20', color: link.resource.color}">
              {{ $getShortName(link.resource.name) }}
            </span>

            </div>

            <div class="link">
              <template v-if="link.edit">
                <div class="edit-link">
                  <div class="inputs">
                    <input type="text" class="form-control" v-model="link.link" placeholder="Ссылка" required>
                    <input type="text" class="form-control" v-model="link.name" placeholder="Название ссылки">
                    <input type="text" class="form-control" v-model="link.city" placeholder="Город">
                    <input type="text" class="form-control" v-model="link.address" placeholder="Адрес">
                  </div>
                  <button class="btn" title="Сохранить" @click.prevent="saveLink(link)"><i class="bi bi-check-lg"></i>
                  </button>
                  <button class="btn" title="Отмена" @click.prevent="link.edit = false"><i class="bi bi-x-lg"></i>
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="name">
                  <span>{{ link.link }}</span>
                  <span class="help-text">{{ link.name }} {{ link.city }} {{ link.address }}</span>
                </div>
                <a href="" class="text-primary" title="Редактировать" @click.prevent="link.edit=true">
                  <i class="bi bi-pencil"></i>
                </a>
              </template>
            </div>
            <div class="buttons ms-auto">
              <div class="col">

                <div class="form-check form-check-inline link-checker" title="Регулярная проверка">
                  <input v-model="link.checker" class="form-check-input"
                         @change="saveLink(link)"
                         type="checkbox" name="inlineRadioOptions" :id="'link_checker_'+link.id">
                  <label class="form-check-label" :for="'link_checker_'+link.id"><i class="bi bi-alarm"></i></label>
                </div>
              </div>
              <div class="col">


                <template v-if="!link.add_group">
                  <div class="d-flex">
                    <select style="min-width: 150px" name="" id="" :class="'form-control'+(!link.group? ' empty':'')"
                            @change="changeGroup(link)"
                            v-model="link.group">
                      <option :value="null" disabled hidden>Выберите группу</option>
                      <option v-for="group in groups" :value="group">{{ group.name }}</option>
                    </select>
                    <button class="btn btn-outline-success btn-sm" @click="link.add_group = {name: ''}">+</button>
                  </div>
                </template>
                <template v-else>
                  <div class="d-flex">
                    <input class="form-control" placeholder="Название группы" v-model="link.add_group.name">
                    <button class="btn btn-sm btn-success" @click="createLineGroup(link)" title="Сохранить"><i
                        class="bi bi-check-lg"></i></button>
                    <button class="btn btn-sm btn-danger" @click="link.add_group=null" title="Отмена"><i
                        class="bi bi-x-lg"></i></button>
                  </div>
                </template>
              </div>

              <a href="" class="text-danger" title="Удалить"
                 @click.prevent="delete_link = link; $modal('show', 'delete_link')">
                <i class="bi bi-trash3"></i>
              </a>
            </div>
          </li>
        </ul>
        <PagerList class="mt-3" v-bind:pager="response_pager" v-bind:updatePage="updateResponsePage"
                   v-bind:page="page"></PagerList>
      </div>
    </div>

    <modal modal_id="add_site">
      <template v-slot:header>
        <h4 v-if="modal_data.length">Сбор данных на следующих доменах не подерживается</h4>
        <h4 v-else>Успешно загружено</h4>
      </template>
      <template v-slot:body>
        <div v-if="save_answer.length">
          <p v-for="error in save_answer">{{ error }}</p>
        </div>

        <div v-if="modal_data.length" class="domain-support">
          <strong>Неподдерживаемые домены:</strong>
          <ul>
            <li v-for="modal_d in modal_data">{{ modal_d }}</li>
          </ul>
          <button class="btn btn-secondary" title="Копировать" @click.prevent="copyModalData"><i
              class="bi bi-copy"></i></button>
        </div>
        <p v-if="modal_data.length">Вы можете отправить обращение о возможности добавить поддержку доменов</p>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'add_site')"
                data-bs-dismiss="modal">Закрыть
        </button>
        <button type="button" v-if="modal_data.length" class="btn btn-primary" @click="sendRequest"
                data-bs-dismiss="modal">Отправить
        </button>
      </template>
    </modal>
    <modal modal_id="delete_link">
      <template v-slot:header>
        <h4>Удаление объекта</h4>
      </template>
      <template v-slot:body>

        <h6 v-if="delete_link">Вы уверены, что хотите удалить ссылку <br>
          <a :href="delete_link.link" target="_blank">{{ delete_link.link }}</a>?</h6>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'delete_link')"
                data-bs-dismiss="modal">Закрыть
        </button>
        <button type="button" class="btn btn-danger" @click="deleteLink(delete_link?.id)"
                data-bs-dismiss="modal">Удалить
        </button>
      </template>
    </modal>
    <modal modal_id="load_links">
      <template v-slot:header>
        <h4>Введите ссылки или загрузите файл</h4>
      </template>
      <template v-slot:body>
        <div class="form-item">
          <label for="">Выберите группу</label>
          <template v-if="!create_group">
            <div class="d-flex">
              <select name="" id="" class="form-control" v-model="load.group">
                <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
              </select>
              <button class="btn btn-outline-primary btn-sm" @click="create_group = {name: ''}">Добавить</button>
            </div>
          </template>
          <template v-else>
            <div class="d-flex">
              <input class="form-control" placeholder="Название группы" v-model="create_group.name">
              <button class="btn btn-sm btn-primary" @click="createGroup">Сохранить</button>
              <button class="btn btn-sm btn-danger" @click="create_group=null">X</button>
            </div>
          </template>
        </div>
        <div class="form-item">
          <label for="">Введите ссылки<sup>*</sup> <sub>(каждая ссылка с новой строки)</sub></label>
          <textarea v-model="load.text" name="" id="" cols="30" rows="30" style="height: 150px"
                    class="form-control"></textarea>
        </div>
        <div class="form-item">
          <label for="">Или загрузите файл<sup>*</sup> </label>
          <input type="file" ref="load_link" class="form-control"
                 accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
        </div>
        <ExelExample></ExelExample>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'load_links')"
                data-bs-dismiss="modal">Закрыть
        </button>
        <button type="button" class="btn btn-primary" @click="sendFile($refs.load_link)"
                data-bs-dismiss="modal">Загрузить
        </button>
      </template>
    </modal>
    <modal modal_id="resource_all_list">
      <template v-slot:header>
        <h4>Поддерживаемые домены</h4>
      </template>
      <template v-slot:body>
        <ul class="list-unstyled resources">
          <li v-for="resource in resources">
            <div class="resource-ico">
                  <span class="img" v-if="resource?.ico"
                        :style="{backgroundImage: `url(${resource.ico})`}"></span>
              <span class="img no-image" v-else :style="{backgroundColor: resource?.color}"></span>

              <span class="name">{{ resource?.name || resource?.domain }}</span>
            </div>
          </li>
        </ul>
      </template>
    </modal>
  </div>
</template>

<script>
import PagerList from "@/components/PagerList.vue";
import {LinksApi} from "@/api/links";
import ExelExample from "@/views/project/components/ExelExample.vue";
import {ProjectApi} from "@/api/projects";

export default {
  name: 'LinkSettings',
  components: {ExelExample, PagerList},
  props: {
    groups: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      objects: [],
      save_answer: [],
      modal_data: [],
      resources: [],
      create_group: null,
      size: 10,
      delete_link: null,
      all_count: 0,
      page: 1,
      search: "",
      load: {},
      validate: {
        link: {
          func: (o) => {
            return !o.link || !this.$func.isURL(o.link)
          }, error: 'Неверный формат ссылки'
        },
      }
    }
  },
  watch: {
    page() {
      this.getData();
    }
  },
  mounted: function () {
    this.getData();
    ProjectApi.resource_all_list().then(response => this.resources = response)
  },
  computed: {
    response_pager() {
      return this.$func.getPagerArray(this.all_count, this.size, this.page)
    },
    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    }
  },
  methods: {
    createGroup(group, index) {
      this.create_group.project_id = this.project_id;
      LinksApi.review_group_create(this.create_group).then(response => {
        this.load.group = response.id;
        this.create_group = null;
        this.groups.push(response)
        this.$emit('update:groups', this.groups);
      });
    },
    saveLink(link) {
      if (!link.link) {
        this.$notify({
          type: "error",
          text: 'Ссылка обязательна для заполнения'
        })
      } else {
        LinksApi.save_link(link).then(response => {
          if (response.error) {
            this.$notify({
              type: "error",
              text: response.error
            })
          } else {
            if(response.message_error) {
              this.$notify({
                type: "error",
                text: response.message_error
              })
            }
            else{
              this.$notify({
                type: "success",
                text: 'Данные сохранены'
              })
            }
            const index = this.objects.findIndex(x=>x.id===link.id)
            this.objects.splice(index, 1, response);
          }
        })
      }
    },

    deleteLink(link_id) {
      LinksApi.delete(link_id).then(() => {
        let index = this.objects.findIndex(x => x.id === link_id)
        this.objects.splice(index, 1)
        this.delete_link = null;
        this.$modal('hide', 'delete_link')
        this.$notify({
          type: "success",
          text: 'Ссылка удалена'
        })
      })
    },

    updateResponsePage(page) {
      this.page = page
    },

    changeGroup(object) {
      LinksApi.review_group_set(object.id, {group_id: object.group.id})
    },

    createLineGroup(object) {
      const $this = this;
      let data = object.add_group;
      if (data.name) {
        data.project_id = this.project_id
        LinksApi.review_group_add(data).then(group => {
          // Обновляем группы в родительской компоненте
          this.$emit('group-created', group);
          object.group = group;
          object.add_group = null;
          this.changeGroup(object);
        })
      } else {
        this.$notify({
          type: "error",
          text: 'Введите название'
        })
      }
    },

    getData() {
      let $this = this;
      LinksApi.get_list($this.page, $this.size, this.search ? `link=${this.search}` : '').then(response => {
        $this.objects = response.results;
        $this.all_count = response.count;
      });
    },

    sendFile(ref) {
      const $this = this;
      let formData = new FormData();
      formData.set('file', ref.files[0]);
      if (this.load.text) formData.set('text', this.load.text);
      formData.set('group', this.load.group);
      formData.set('project_id', this.project_id);
      if (ref.files[0] || this.load.text) {
        LinksApi.load_file(formData).then(response => {
          if (response.answer) $this.save_answer = response.answer;
          if (response.message) {
            $this.$notify({
              type: response.message.status,
              text: response.message.text
            })
          }
          if (response.answer) {
            $this.save_answer = response.answer;
            if (response.domains) $this.modal_data = response.domains
            $this.$modal('hide', 'load_links')
            $this.$modal('show', "add_site")
            $this.load.text = ""
          }

          $this.$refs.load_link.value = null;
          $this.getData()
        })
      } else {
        $this.$notify({
          type: "error",
          text: 'Загрузите файл или заполните текстовое поле'
        })
      }
    },

    copyModalData() {
      let textToCopy = this.modal_data.join('\n');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
              this.$notify({
                type: "success",
                text: 'Список скопирован в буфер обмена'
              })
            })
            .catch(err => {
              console.error('Ошибка копирования:', err);
              this.fallbackCopyText(textToCopy);
            });
      } else {
        this.fallbackCopyText(textToCopy);
      }
    },

    fallbackCopyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Ошибка копирования (fallback):', err);
      }
      document.body.removeChild(textarea);
    },

    sendRequest() {
      const $this = this;
      LinksApi.request_domain(this.name, this.modal_data).then(() => {
        $this.$modal("hide", "add_site")
        $this.$notify({
          type: "success",
          text: 'Обращение отправлено'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search-area {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;

  input {
    max-width: 350px;
  }
}

ul.resources {
  list-style: none;

  .resource-ico {
    display: flex;
    gap: 4px;
    align-items: center;
    margin-bottom: 10px;

    .img {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-position: center;
      background-size: contain;

      &.no-image {
        background: #ccc;
        border-radius: 16px;
      }
    }

    .name {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
}

select.empty {
  color: gray;
}

.links {
  display: flex;
  gap: 15px;
  flex-direction: column;


  li {
    border: 1px solid var(--soft-grey);
    padding: 10px;
    width: 100%;
    display: flex;
    gap: 15px;

    align-items: center;

    .edit-link {
      display: flex;
      width: 100%;
      gap: 10px;

      .inputs {
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100%;
      }
    }

    .link {

      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-right: 30px;
    }

    .buttons {
      display: flex;
      align-items: center;
      gap: 20px;
      .link-checker{
        font-size: 16px;
        input, label{
          cursor: pointer;
        }
      }
    }
  }
}

.domain-support {
  position: relative;

  ul {
    height: 150px;
    overflow: auto;
    padding-left: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .btn {
    position: absolute;
    right: 25px;
    top: 30px;
  }
}

@media (width < 768px) {
  .links {
    width: 100%;
    overflow-x: auto;
  }
  .links.groups {
    column-count: 1;
  }
}
</style>

